/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import React, { ReactNode } from 'react';
import style from './MedicalScoreDisplay.scss?inline';
import { useCSS } from '../../../provider/CSSProvider';
import { Typography } from '@mui/material';
import { convertToRomanNumber } from '../../../utils/util';

interface MedicalScoreDisplayProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: ReactNode;
  medicalScore?: number | null;
  subtitle?: ReactNode;
  /**
   * When true, the score value is displayed as roman numeral.
   */
  romanScore?: boolean;
  asHeader?: boolean;
}

export default function MedicalScoreDisplay(props: MedicalScoreDisplayProps) {
  useCSS(style);

  const { header, medicalScore, subtitle, romanScore, asHeader, className, ...htmlAttributes } = props;

  function getScoreLabel(score: number | null | undefined): string {
    if (score === null || score === undefined) {
      return '--';
    }
    if (romanScore) {
      return convertToRomanNumber(score);
    } else {
      return score.toString();
    }
  }

  return (
    <div {...htmlAttributes} className={`column medical-score-display ${className ?? ''}`}>
      <div className='medical-score-display-header title-content'>
        <Typography variant={asHeader ? 'h2' : 'body1'}>{header}</Typography>
        <Typography variant='body1' className='accent'>
          {getScoreLabel(medicalScore)}
        </Typography>
      </div>
      <Typography className='medical-score-display-description' variant='subtitle2'>
        {subtitle}
      </Typography>
    </div>
  );
}
